<template>
  <div v-resize="onResize">
  <v-app-bar app class="mt-0 hl-bar" :height="header_height" color="#FFFFFF" dark fixed flat>
      <div class="hl-wrap" :class="header_rotate">
        <!-- ===== ซ้าย: เมนู + โลโก้ + ชื่อหน้า ===== -->
        <div class="hl-left">
          <button
            v-if="$store.getters['isLogin']"
            type="button"
            class="hl-icon-btn hl-icon-btn--plain"
            @click="$store.state.navMenu = !$store.state.navMenu"
          >
            <v-icon size="22" color="#475569">mdi-menu</v-icon>
          </button>
            <!-- <v-btn text dark @click="onClickMenu('/')">
             <h3 v-if="!$store.getters['isLogin']">{{this.lg_header_menu.home}}</h3>
              <h4 v-if="$store.getters['isLogin']">{{this.lg_header_menu.home}}</h4>
            </v-btn>
            <v-btn text dark @click="onClickMenu('/pricing')">
              <h3 v-if="!$store.getters['isLogin']">{{this.lg_header_menu.feature}}</h3>
              <h4 v-if="$store.getters['isLogin']">{{this.lg_header_menu.feature}}</h4>
            </v-btn>
            <v-btn text dark @click="onClickMenu('/contact')">
              <h3 v-if="!$store.getters['isLogin']">{{this.lg_header_menu.contact}}</h3>
              <h4 v-if="$store.getters['isLogin']">{{this.lg_header_menu.contact}}</h4>
            </v-btn>
            <v-btn text dark @click="onClickMenu('/joinmeetid')">
              <h3 v-if="!$store.getters['isLogin']">{{this.lg_header_menu.joinmeetbyid}}</h3>
              <h4 v-if="$store.getters['isLogin']">{{this.lg_header_menu.joinmeetbyid}}</h4>
            </v-btn> -->

          <div v-if="$store.getters['isLogin']" class="hl-logo">
            <template v-if="this.acc_plan === 'FREE'">
              <!-- class="hidden-sm-and-down" -->
              <img src="../../assets/logo.png" alt="Dmeets" class="hl-logo-img" />
              <span class="hl-logo-text">meets</span>
            </template>
          <!-- <div :class="header_mt" v-else>
            <v-img
              src="../../assets/logo_at_law.png"
              :max-height="width"
              :max-width="width"
              sm="12"
              cols="12"
            ></v-img>
          </div> -->
          </div>

          <div v-if="!$store.getters['isLogin']" class="hl-logo">
            <img src="../../assets/logo.png" alt="Dmeets" class="hl-logo-img" />
            <span class="hl-logo-text">meets</span>
          </div>

          <h1 v-if="pageTitle" class="hl-page-title">{{ pageTitle }}</h1>
        </div>

        <!-- ===== ขวา: ผู้ใช้ + ภาษา + ออกจากระบบ ===== -->
        <div class="hl-right">
          <!-- มือถือ / แท็บเล็ต: ไอคอนผู้ใช้ + เมนู -->
          <div v-if="$store.getters['isLogin']" class="hidden-md-and-up">
            <button id="acc-menu" type="button" class="hl-avatar-btn">
              <span class="hl-avatar"><v-icon size="16" color="#ffffff">mdi-account</v-icon></span>
            </button>

            <v-menu activator="#acc-menu" offset-y left>
              <v-list dense>
                <v-list-item link @click="onClickMenu('/account-detail')">
                  <v-list-item-title>
                    {{ showfullname }}
                    <!-- ( {{ $store.getters["role"] }} ) -->
                  </v-list-item-title>
                </v-list-item>
                  <!-- <v-list-item v-if="this.acc_plan === 'FREE'">
                    <v-btn text text-transform-none v-if="this.acc_plan === 'FREE'">
                      <h4 style="color: yellow" v-if="$store.getters['isLogin']">
                        Free ( {{ this.date_exire }}-Day )
                      </h4>
                    </v-btn>
                  </v-list-item> -->
                  <!-- <v-list-item>
                    <v-btn text text-transform-none>
                      <h4 v-if="$store.getters['isLogin']">
                        {{ $store.getters["company_name"] }}
                      </h4>
                    </v-btn>
                  </v-list-item> -->
              </v-list>
            </v-menu>
          </div>

          <!-- จอใหญ่: ชิปชื่อผู้ใช้ -->
          <button
            v-if="$store.getters['isLogin']"
            type="button"
            class="hl-user hidden-sm-and-down"
            @click="onClickMenu('/account-detail')"
          >
            <span class="hl-avatar"><v-icon size="16" color="#ffffff">mdi-account</v-icon></span>
            <span class="hl-user-name">
              {{ showfullname }}
              <!-- ({{ $store.getters["role"] }} ) -->
            </span>
          </button>

            <!-- <v-btn text text-transform-none v-if="this.acc_plan === 'FREE'">
              <h4 style="color: yellow" v-if="$store.getters['isLogin']">
                Free ( {{ this.date_exire }}-Day )
              </h4>
            </v-btn> -->
        

            <!-- <v-btn text text-transform-none>
              <h4 v-if="$store.getters['isLogin']">
                {{ $store.getters["company_name"] }}
              </h4>
            </v-btn> -->

          <v-menu offset-y left>
            <template v-slot:activator="{ attrs, on }">
              <!--  :x-small="!buttonsizesmall" -->
              <!--  class="positionflag" -->
              <button type="button" class="hl-lang" v-bind="attrs" v-on="on">
                <!-- <country-flag :country="defaultlanguage" size="normal" />  -->
                <v-icon size="16" color="#4b5563">mdi-web</v-icon>
                <span class="hl-lang-text">{{ defaultlanguage }}</span>
                <v-icon size="16" color="#9ca3af">mdi-chevron-down</v-icon>
              </button>
            </template>

            <v-list dense>
              <v-list-item
                v-for="(item,idx) in chooselanguage"
                :key="idx"
                link
                @click="onChange(item.flag)"
              >
                {{ item.full_name }}
                <!-- <country-flag :country="item.flag" size="normal" /> -->
              </v-list-item>
            </v-list>
          </v-menu>

          <button
            v-if="$store.getters['isLogin']"
            type="button"
            class="hl-icon-btn"
            @click.prevent="onClickLogOff"
          >
            <v-icon size="18" color="#475569">mdi-logout</v-icon>
          </button>
        </div>
      </div>

      <!-- class="hidden-md-and-up" -->
      <!-- <v-toolbar-title>{{ title }} V{{ version }}</v-toolbar-title> -->
    </v-app-bar>
  </div>
</template>

<script>
import api from "@/services/api";
import { server } from "../../services/constants";
import { feature } from "../../services/constants";
import SwitchLang from "vue-switch-lang";
import {lg_header_menu} from '../../views/language/lg_header_menu.js';

export default {
  name: "Header",
  data: () => ({
    drawer: false,
    text_fontsize: 30,
    dialog: false,
    mLoc: "left",
    header_rotate: "",
    header_mt: "",
    acc_plan: "",
    date_exire: 0,
    role: "",
    id: "",
    menu: [
      { icon: "home", title: "หน้าหลัก" },
      { icon: "info", title: "ฟีเจอร์" },
      { icon: "info", title: "ติดต่อเรา" },
    ],
      defaultlanguage: "",
      // regexlang: "th",
      chooselanguage: [
        { name: "en", flag: "gb",full_name:"English" },
        { name: "th", flag: "th",full_name:"ภาษาไทย" },
      ],
  }),
  components: {
    SwitchLang,
  },
  async mounted() {
    this.$forceUpdate();
    // this.$router.go(); // Refreshes page
    this.acc_plan = localStorage.getItem("acc_plan");
    this.role = localStorage.getItem("role");
    this.id = localStorage.getItem("user_id");
    // alert(this.id);
    // alert(this.acc_plan);
    // alert(this.role);
    const res = await api.getDateExpire(this.id);
    this.date_exire = res.data.value_expire;
    // alert(this.date_exire);
    // console.log("date_exire : " + this.date_exire);
  },
  computed: {
    // ชื่อหน้าที่แสดงข้าง logo (เพิ่ม path อื่นได้ตามต้องการ)
    pageTitle() {
      const lg = this.lg_header_menu || {};
      const path = this.$route ? this.$route.path : "";
      if (path.startsWith("/listroom")) return lg.lh_my_meetings || "";
      if (path.startsWith("/account-detail")) return lg.lh_account || "";
      return "";
    },
     showfullname() {
    return localStorage.getItem(server.FULLNAME);
  },
    version() {
      return process.env.VUE_APP_VERSION;
    },
    title() {
      return process.env.VUE_APP_TITLE;
    },
    width() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 60;
        case "sm":
          return 60;
        case "md":
          return 60;
        case "lg":
          return 60;
        case "xl":
          return 60;
      }
    },
    header_height() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 70;
        case "sm":
          return 70;
        case "md":
          return 70;
        case "lg":
          return 70;
        case "xl":
          return 70;
      }
    },
    mLoc2(){
  switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "end";
        case "sm":
          return "end";
        case "md":
          return  "end";
        case "lg":
          return  "end";
        case "xl":
          return  "end";
      }
    },
  },
  methods: {
    onChange(lang) {
      // Do something
      // alert(lang.title);
      // this.defaultlanguage = lang;
      localStorage.setItem(feature.LANGUAGE, lang);
       if(localStorage.getItem(feature.LANGUAGE) == "th"){
      this.defaultlanguage = "ภาษาไทย";
      }else{
        this.defaultlanguage = "English";
      }
      // alert(localStorage.getItem(feature.LANGUAGE));
      // console.log("language header : " + localStorage.getItem(feature.LANGUAGE));
      this.$router.go();
    },
    onResize: function () {
      // console.log(
      //   "Window width: " +
      //     window.innerWidth +
      //     ", breakpoint width: " +
      //     this.$vuetify.breakpoint.width +
      //     ", breakpoint name: " +
      //     this.$vuetify.breakpoint.name
      // );
      if (window.innerWidth < 600) {
        this.header_rotate = "column";
        this.header_mt = "mt-5";
        this.mLoc = "left";
      } else {
        this.header_rotate = "row";
        this.header_mt = "mt-0";
        this.mLoc = "left";
      }
    },
    onClickLogOff() {
      this.$store.dispatch("doLogout");
      // alert("Test");
    },
    onClickMenu(link) {
      // this.$store.state.navMenu = false;
      this.$router.push(link).catch((err) => {});
    },
  },
   async beforeCreate() {
      this.$store.state.page_reload = false;
      // this.defaultlanguage =  localStorage.getItem(feature.LANGUAGE);
       if(localStorage.getItem(feature.LANGUAGE) == "th"){
      this.defaultlanguage = "ภาษาไทย";
      }else{
        this.defaultlanguage = "English";
      }
      // alert(localStorage.getItem("language"))
      // console.log("language login : " + localStorage.getItem(feature.LANGUAGE));

      localStorage.getItem(feature.LANGUAGE) === "th"
        ? this.lg_header_menu = lg_header_menu.lg_header_menu_th
        : this.lg_header_menu = lg_header_menu.lg_header_menu_en;

        // console.log("lg_login: " + JSON.stringify(this.lg_login));
    },
    async created() {
      this.$store.state.page_reload = false;
  // this.defaultlanguage =  localStorage.getItem(feature.LANGUAGE);
     if(localStorage.getItem(feature.LANGUAGE) == "th"){
      this.defaultlanguage = "ภาษาไทย";
      }else{
        this.defaultlanguage = "English";
      }
  this.onResize()
    },
};
</script>

<style scoped>
.v-application .positionflag{
    padding-bottom: 5px;
    padding-right: 0px;
}

/* ===================== UI ใหม่ (header หลัง login) ===================== */
.hl-bar {
  background: #ffffff !important;
  border-bottom: 1px solid #e2e8f0 !important;
}
.hl-bar ::v-deep .v-toolbar__content { padding: 0; }
.hl-wrap {
  width: 100%;
  max-width: 1232px;
  margin: 0 auto;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.hl-left,
.hl-right { display: flex; align-items: center; gap: 12px; min-width: 0; }
.hl-right { gap: 8px; flex-shrink: 0; }

/* Logo */
.hl-logo { display: flex; align-items: center; gap: 6px; flex-shrink: 0; }
.hl-logo-img { width: 32px; height: 32px; object-fit: contain; border-radius: 8px; }
.hl-logo-text { font-size: 18px; color: #215295; opacity: 0.85; line-height: 1; }
.hl-page-title {
  margin: 0 0 0 28px;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Buttons */
.hl-icon-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.hl-icon-btn:hover { background: #f8fafc; }
.hl-icon-btn--plain { border-color: transparent; }

.hl-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #3b6cb0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.hl-avatar-btn { background: none; border: 0; padding: 4px; cursor: pointer; display: inline-flex; }
.hl-user {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 0 14px 0 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  font: inherit;
  max-width: 260px;
  transition: background-color 0.15s ease;
}
.hl-user:hover { background: #e8eef6; }
.hl-user-name {
  font-size: 14px;
  font-weight: 500;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hl-lang {
  height: 36px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font: inherit;
  font-size: 13px;
  color: #4b5563 !important;
  cursor: pointer;
}
.hl-lang:hover { background: #f8fafc; }

@media (max-width: 599px) {
  .hl-wrap { padding: 0 8px; gap: 8px; }
  .hl-page-title { display: none; }
  .hl-lang-text { display: none; }
  .hl-lang { padding: 0 8px; }
}
</style>